import React, {createContext, useContext} from "react";

export const ToastsContext = createContext({
  // default values
  toasts: [],
  addToast: () => {},
  removeToast: el => {},
  toastsVisible: false,
});

const useToastsContext = () => useContext(ToastsContext);

const AddToast = () => {
  const {addToast} = useToastsContext();

  return <button onClick={addToast}>Add toast</button>;
}

const ToastList = () => {
  const {toasts, toastsVisible, removeToast} = useToastsContext();

  if (!toastsVisible) {
    return null;
  }
  return toasts.map(toast => (
    <div key={toast}>
      Toast with id: {toast}
      <br />
      <button onClick={() => removeToast(toast)}>Remove me</button>
    </div>
  ))
}

export const ContextToastsComponent = () => (
  <>
    <br />
    <AddToast />
    <ToastList />
  </>
)

